import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDice } from '@fortawesome/free-solid-svg-icons';

/** Chỉ hiển thị giải hạng 4-20 — top 3 đã có giá trị giải trong podium bên trên */
function TopCashBackPrizes() {
    return (
        <div className="mx-4 mb-2 pt-6 flex gap-2">
            <div className="flex-1 flex items-center justify-between bg-blue-50 border border-blue-100 rounded-xl px-2.5 py-1.5">
                <span className="text-[11px] font-semibold text-blue-700">🎯 Hạng 4 – 10</span>
                <span className="text-[11px] font-bold text-blue-700">+100.000đ</span>
            </div>
            <div className="flex-1 flex items-center justify-between bg-purple-50 border border-purple-100 rounded-xl px-2.5 py-1.5">
                <span className="text-[11px] font-semibold text-purple-700">🎲 Hạng 11 – 20</span>
                <span className="text-[11px] font-bold text-purple-700 flex items-center gap-1">
                    <FontAwesomeIcon icon={faDice} size="xs" className="opacity-60" />
                    May mắn
                </span>
            </div>
        </div>
    );
}

export default TopCashBackPrizes;
